import { render, staticRenderFns } from "./Sponsorship.vue?vue&type=template&id=49400b8c&scoped=true"
var script = {}
import style0 from "./Sponsorship.vue?vue&type=style&index=0&id=49400b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49400b8c",
  null
  
)

export default component.exports